import {
  GET_ALL_COUPONS_REQUEST,
  GET_ALL_COUPONS_SUCCESS,
  GET_ALL_COUPONS_FAILURE,
} from '../constants';

export interface Coupon {
  couponName: string;
  couponCode: string;
  offerType: number;
  discountAmount: number;
  minQuantity: number;
  minOrderValue: number;
  startDate: string;
  endDate: string;
  status: number;
  categories: number[];
  requirementType: number[] | number;
  applicableForCashOnly: boolean;
  deliveryType?: number;
  isCouponValid: boolean;
}

interface CouponsState {
  couponsDataRequest: boolean;
  coupons: { data: Coupon[] };
  couponsDataStatus: boolean;
  couponsDataError: string | null;
}

const initialState = {
  couponsDataRequest: false,
  coupons: { data: [] as Coupon[] },
  couponsDataStatus: false,
  couponsDataError: null as string | null,
};

interface actionType {
  type: string;
  payload: {
      data?: any;
      error?: string;
  };
}

export const getCouponsReducer = (state: CouponsState = initialState, action: actionType) => {
  switch (action.type) {
    case GET_ALL_COUPONS_REQUEST:
      return {
        ...state,
        couponsDataRequest: true,
        coupons: initialState.coupons,
        couponsDataStatus: true,
        couponsDataError: null as string | null,
      };
    case GET_ALL_COUPONS_SUCCESS:
      return {
        ...state,
        couponsDataRequest: false,
        coupons: action.payload.data,
        couponsDataStatus: true,
        couponsDataError: null as string | null,
      };
    case GET_ALL_COUPONS_FAILURE:
      return {
        ...state,
        couponsDataRequest: false,
        coupons: initialState.coupons,
        couponsDataStatus: false,
        couponsDataError: action.payload?.error || null,
      };

    default:
      return state;
  }
};
